// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__thw5-","footer":"ModalCreateQualiphyProcedure_footer__1PkCT","additionData":"ModalCreateQualiphyProcedure_additionData__1oSll"};